import React from 'react';

export default (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

  const buttonInfoClicked = () => {
    
    const url = `${window.location.origin}/web/device.html?wfmc=${props.data.wfmc}`;
    window.open(url, "_blank")
  };

  const buttonQRClicked = () => {
    
    const url = `${window.location.origin}/web/deviceQR.html?wfmc=${props.data.wfmc}`;
    window.open(url, "_blank")
  };

  return (
    <span>      
      <button onClick={() => buttonInfoClicked()}>Info</button>
      <button onClick={() => buttonQRClicked()}>QR</button>
    </span>
  );
};